import styled, { css } from 'styled-components';
import { CardGridStyled } from '../../styled/cardGrid.styled';
import { Breakpoints } from '../../styled/constants';

interface VipProps {
  $isVipPage?: boolean;
  $isMainVipPage?: boolean;
}

const vipStyles = css<VipProps>`
  ${({ $isVipPage }) =>
    $isVipPage &&
    css`
      padding: 0 10px 15px;

      @media screen and (min-width: ${Breakpoints.tablet}px) {
        padding: 10px 0 15px;
      }
    `}

  ${({ $isMainVipPage }) =>
    $isMainVipPage &&
    css`
      padding-top: 15px;
    `}
`;

export const SectionListBase = styled.div<VipProps>`
  position: relative;
  font-size: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px 0 1px;

  ${vipStyles}
`;

export const SectionListGrid = styled(CardGridStyled)<VipProps>`
  ${vipStyles}
`;
